import { featured } from '@/mocks/siteContent';
import { VerdictChip } from './kit';

export default function Featured() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <p className="mb-3 font-label text-xs font-semibold tracking-[0.25em] text-accent-600">
            栏目 · {featured.kicker}
          </p>
          <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl md:leading-snug">
            {featured.title}
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
            {featured.sub}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <VerdictChip verdict="debunked" />
            <span className="text-xs text-foreground-500">定论时间 · 2026-05-02</span>
            <span className="hidden text-xs text-foreground-500 sm:inline">来源编号 · S-260502-07</span>
          </div>
        </div>

        <div className="lg:col-span-5">
          <ol className="relative space-y-0 border-l border-background-300 pl-6">
            {featured.timeline.map((t) => (
              <li key={t.tag} className="relative pb-6 last:pb-0">
                <span className="absolute -left-[29px] top-0.5 flex h-3 w-3 items-center justify-center">
                  <span className="h-2.5 w-2.5 rounded-full bg-accent-500" />
                </span>
                <h3 className="mb-1 font-label text-xs font-semibold tracking-wide text-accent-700">
                  {t.tag}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-800">{t.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}